<template>
  <SMSelect v-model="value">
    <SMOption
      v-for="(option, index) in categories"
      :key="index"
      :value="option.id"
      :disabled="option.id === 0"
      class="flex gap-2 items-center"
    >
      <div v-if="option.id" class="color w-5 h-5" :style="{ background: option.color }" />
      <div>{{ option.name }}</div>
      <div v-if="option.id">&nbsp;({{ option.price }})</div>
    </SMOption>
  </SMSelect>
</template>

<script setup lang="ts">
import { PropType, computed } from 'vue';
import SMSelect from './SMSelect.vue';
import SMOption from './SMOption.vue';

const props = defineProps({
  modelValue: {
    type: [String, Number],
  },
  categories: {
    type: Array as PropType<{ id: number; name: string; color: string; price: number }[]>,
    required: true,
  },
});

const emits = defineEmits(['update:modelValue', 'change']);

const value = computed({
  get: () => props.modelValue,
  set: (value) => {
    emits('update:modelValue', value);
    emits('change', value);
  },
});
</script>
